import { render, staticRenderFns } from "./Arm.vue?vue&type=template&id=f6f97590&scoped=true"
import script from "./Arm.vue?vue&type=script&lang=js"
export * from "./Arm.vue?vue&type=script&lang=js"
import style0 from "./Arm.vue?vue&type=style&index=0&id=f6f97590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f97590",
  null
  
)

export default component.exports